import { createFileRoute } from '@tanstack/react-router';
import { useCallback } from 'react';

import { SecretPagesPage } from '@/features/banners/SecretPagesPage';

export interface SecretPagesSearch {
  /** Открытая форма: `new` — создание, идентификатор — правка. */
  edit?: string;
}

/**
 * Секретные страницы — свой адрес внутри раздела баннеров (AUI-DSN-02).
 *
 * Отдельная страница, а не вкладка списка баннеров: у страниц нет ни размещения, ни порядка
 * показа, зато есть адрес и набор товаров, и сведённые в один список они выглядели бы
 * баннерами, которых у них нет.
 */
export const Route = createFileRoute('/_app/banners_/secret-pages')({
  validateSearch: (search: Record<string, unknown>): SecretPagesSearch => ({
    edit: typeof search.edit === 'string' && search.edit !== '' ? search.edit : undefined,
  }),
  component: SecretPagesRoute,
});

function SecretPagesRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  const onEditingChange = useCallback(
    (edit: string | null) => {
      void navigate({
        search: (previous) => ({ ...previous, edit: edit ?? undefined }),
        // Открытие и закрытие формы — шаг истории: «назад» из формы возвращает к списку,
        // как и ожидается от бокового экрана, открытого по ссылке.
        replace: false,
      });
    },
    [navigate],
  );

  return <SecretPagesPage editing={search.edit ?? null} onEditingChange={onEditingChange} />;
}
